import formatDate from 'date-fns/format';
import PropTypes from 'prop-types';
import React from 'react';
import Cell from './Cell';
const DateCell = /*#__PURE__*/React.memo(_ref => {
  let {
    date,
    format,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Cell, props, date ? formatDate(date, format.replace(/D/g, 'd').replace(/Y/g, 'y')) : '');
}); // just in case somewhere in the project the old formatting tokens are used

DateCell.propTypes = {
  date: PropTypes.any,
  format: PropTypes.string
};
DateCell.defaultProps = {
  format: 'MMM d, yyyy'
};
DateCell.displayName = 'DateCell';
export default DateCell;